import React from "react";
import UtilMethods from "../../util/UtilMethods";

// Helper function to determine the modal class based on message type
const getModalClassName = (type) => {
  switch (type) {
    case "error":
      return "alert-danger"; // Bootstrap error style
    case "warning":
      return "alert-warning"; // Bootstrap warning style
    case "info":
      return "alert-info"; // Bootstrap info style
    case "confirmation":
      return "alert-light"; // Light color for confirmation
    case "success":
      return "alert-success"; // Bootstrap success style
    default:
      return "alert-info"; // Default to info if no type is provided
  }
};

// Helper function to return corresponding icon based on type
const getMessageIcon = (type) => {
  switch (type) {
    case "error":
      return <i className="fas fa-exclamation-circle"></i>; // Error icon
    case "warning":
      return <i className="fas fa-exclamation-triangle"></i>; // Warning icon
    case "info":
      return <i className="fas fa-info-circle"></i>; // Info icon
    case "confirmation":
      return <i className="fas fa-question-circle"></i>; // Confirmation icon
    case "success":
      return <i className="fas fa-check-circle"></i>; // Success icon
    default:
      return <i className="fas fa-info-circle"></i>;
  }
};

// Main Modal Component
const AlertModal = ({ show, title, message, details, type, onCancel, onConfirm }) => {

  if (!show) return null; // Do not render if 'show' is false

  return (
    <div className="modal fade show" tabIndex="-1" style={{ display: "block" }}>
      <div className="modal-dialog">
        <div className={`modal-content ${getModalClassName(type)}`}>
          <div className="modal-header">
            <h5 className="modal-title">
              {getMessageIcon(type)} {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onCancel}
            ></button>
          </div>
          <div className="modal-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <p>{UtilMethods.formatTextWithLineBreaks(message)}</p>
            {details && (
              <ul>
                {Object.entries(details).map(([key, value]) => (
                  <li key={key}>
                    <strong>{key}:</strong> {UtilMethods.formatTextWithLineBreaks(value)}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="modal-footer">
            {type === "confirmation" && (
              <>
                <button type="button" className="btn btn-secondary" onClick={onCancel}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={onConfirm}>
                  Confirm
                </button>
              </>
            )}
            {(type === "error" || type === "success" || type === "warning" || type === "info" || type==="danger") && (
              <button type="button" className="btn btn-primary" onClick={onCancel}>
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
